/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import Inline from '@atlaskit/primitives/inline';
import Stack from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import { TabContainer } from './TabContainer.tsx';

export const PlaybookListLoadingView = (): React.JSX.Element => (
	<TabContainer>
		<Stack
			space="space.250"
			grow="fill"
			xcss={wrapperStyles}
			testId="playbooks-list-screen.ui.playbook-list.edge-cases.loading"
		>
			<Inline space="space.100">
				<Skeleton height={32} width={240} borderRadius={token('radius.small')} isShimmering />
				<Skeleton height={32} width={120} borderRadius={token('radius.small')} isShimmering />
			</Inline>
			<Stack space="space.100">
				<LoadingRow />
				<LoadingRow />
				<LoadingRow />
			</Stack>
		</Stack>
	</TabContainer>
);

const LoadingRow = () => (
	<Inline space="space.100">
		<Skeleton height={32} width="30%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="18%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="18%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="18%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="6%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={token('radius.small')} isShimmering />
	</Inline>
);

const wrapperStyles = xcss({
	paddingTop: 'space.300',
});
